import {useContext} from 'react';

import {useTranslation} from 'react-i18next';
import {useNavigate, useSearchParams} from 'react-router-dom';

import {Grid} from '@mui/material';

import {SnackBarContext} from '../../../contexts/SnackBarContext/SnackBarContext';
import {UserContext} from '../../../contexts/UserContext/UserContext';
import {PasswordReset} from '../../../features/user/PasswordReset/PasswordReset';
import {useApiWrite} from '../../../hooks/useApiWrite';
import {Put} from '../../../lib/api/PUT/Put';
import {PutRoutes} from '../../../lib/api/PUT/PutRoutes';
import {AppConfig} from '../../../lib/AppConfig';
import {logout as authServiceLogout} from '../../../services/auth-service';

export const PasswordResetPage = () => {
  const [searchParams] = useSearchParams();
  const {userContextLogout} = useContext(UserContext);
  const {dispatchMessage} = useContext(SnackBarContext);
  const {t} = useTranslation();
  const navigate = useNavigate();

  const id = searchParams.get('id') || '';
  const token = searchParams.get('token');

  const onSuccess = () => {
    authServiceLogout();
    userContextLogout();
    navigate(AppConfig.LOGIN_PATH);
  };

  const onError = () => {
    dispatchMessage(
      t('passwordReset.errorMessage', {
        requestLink: `${process.env.REACT_APP_PLATFORM_BASE_URL}${AppConfig.FORGOT_PASSWORD_PATH}`,
      }),
      'error'
    );
  };

  const {makeRequest} = useApiWrite<Put.ResetPassword>({
    method: 'put',
    path: PutRoutes[Put.ResetPassword](id),
    onSuccess,
    onError,
  });

  const onSubmit = (password: string, passwordRepeat: string) => {
    if (!id || !token) {
      onError();
      return;
    }

    const body = {
      user: {
        password: password,
        passwordConfirmation: passwordRepeat,
        token,
      },
    };
    makeRequest(body);
  };

  return (
    <Grid item display='flex' alignItems='center' justifyContent='center'>
      <Grid style={{backgroundColor: 'white', padding: '3rem', borderRadius: '16px'}}>
        <PasswordReset onSubmit={onSubmit} />
      </Grid>
    </Grid>
  );
};
